import React, { useState, useEffect } from 'react';

export default function Configuration() {
  const [rootCollectionName, setRootCollectionName] = useState('');
  const [imageBucketName, setImageBucketName] = useState('');
  const [catalogPath, setCatalogPath] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saveResult, setSaveResult] = useState(null);

  useEffect(() => {
    fetchConfig();
  }, []);

  async function fetchConfig() {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch('/api/config');
      if (!response.ok) throw new Error('Failed to fetch configuration');
      const data = await response.json();
      setRootCollectionName(data.rootCollectionName);
      setImageBucketName(data.imageBucketName);
      setCatalogPath(data.catalogPath || '');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleSave() {
    try {
      setSaving(true);
      setSaveResult(null);
      const response = await fetch('/api/config', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rootCollectionName, imageBucketName, catalogPath }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Save failed');
      setSaveResult({ success: true });
    } catch (err) {
      setSaveResult({ success: false, error: err.message });
    } finally {
      setSaving(false);
    }
  }

  const canSave = rootCollectionName.trim() && imageBucketName.trim() && catalogPath.trim() && !saving;

  return (
    <div className="product-sync-container">
      <h2>Configuration</h2>
      <p className="subtitle">
        Firestore root collection, image bucket, and catalog path used by all syncs. Changing
        these only affects future syncs — existing data under the old values is left untouched.
      </p>

      {loading && <p className="loading">Loading...</p>}
      {error && <div className="error">✕ {error}</div>}

      {!loading && !error && (
        <div className="config-form">
          <label>
            Root Collection Name
            <input
              type="text"
              value={rootCollectionName}
              onChange={(e) => setRootCollectionName(e.target.value)}
            />
          </label>
          <label>
            Image Bucket Name
            <input
              type="text"
              value={imageBucketName}
              onChange={(e) => setImageBucketName(e.target.value)}
            />
          </label>
          <label>
            Catalog Path
            <input
              type="text"
              value={catalogPath}
              onChange={(e) => setCatalogPath(e.target.value)}
            />
            <small style={{ display: 'block', color: '#888', fontWeight: 'normal', marginTop: '0.25rem' }}>
              Must match the catalog selected in Product Sync's Catalog dropdown — changing this
              without also updating that selection will orphan product category references.
            </small>
          </label>
        </div>
      )}

      <div className="sync-action-bar">
        <button disabled={!canSave} onClick={handleSave}>
          {saving ? 'Saving...' : 'Save Configuration'}
        </button>
      </div>

      {saveResult && (
        <div className={saveResult.success ? 'success-message' : 'error'}>
          {saveResult.success ? 'Configuration saved.' : `Save failed: ${saveResult.error}`}
        </div>
      )}
    </div>
  );
}
